import { h, Ref } from 'preact'
import cls from 'classnames'

import { Field } from 'scripts/type'
import { FieldTitle } from 'components/ui'

import FieldDescription from '../FieldDescription'
import classes from './index.scss'

type Props = {
  field: Field
  titleRef?: Ref<HTMLDivElement>
  className?: string
  titleClass?: string
  descriptionClass?: string
}

const FieldHeader = ({ field, titleRef, className, titleClass, descriptionClass }: Props) => {
  if (field.labelHidden && !field.description) {
    return null
  }
  return (
    <div className={cls(classes.fieldHeader, className)}>
      {!field.labelHidden && <FieldTitle className={titleClass} title={field.label} ref={titleRef} />}
      <FieldDescription
        content={field.description}
        className={cls(descriptionClass, field.labelHidden && classes.ptNone)}
      />
    </div>
  )
}

export default FieldHeader
